export default class ProductMotif {
  id;
  motifData;
  customMotifInputs;

  constructor(motif, cmRequest, id) {
    this.motifData = motif;
    this.customMotifInputs = cmRequest;
    this.id = id;
  }
}
